<div class="d-flex gap-2">
  <img
    src="assets/icons/red/ExclamationCircle.svg"
    alt=""
    height="18"
    width="18"
    [style.height.rem]="1.125"
    [style.width.rem]="1.125" />
  <div class="form-error-text">{{ errorMessage$ | async }}</div>
</div>
